import { Injectable } from '@angular/core';
import { EmployeeCategoryModel } from '../employee-category/employee-category/model/employee-category.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmployeeExtService {

  constructor(private http: HttpClient) { }

  getEmployeeList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/hr/employees/list', requestData);
  }

  getEmployeeById(id: number): Observable<any> {
    return this.http.get(environment.baseUrl + '/hr/employees/' + id);
  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

    return this.http.post(environment.baseUrl + '/employee/exportdatacsv', requestData, { headers, responseType: 'blob' })
      .pipe(
      //catchError(this.handleError)
    );

  }

  /**
  * 
  * @param employeeInfo 
  * Calls the update API to insert/update the record
  */
  update(employeeInfo: any): Observable<any> {
    if (employeeInfo.hasOwnProperty("employee_id") && employeeInfo.employee_id != 0) {
      return this.http.put(environment.baseUrl + '/hr/employees/' + employeeInfo.employee_id, employeeInfo);
    } else {
      return this.http.post(environment.baseUrl + '/hr/employees', employeeInfo);
    }
  }


  /**
 * 
 * @param employeeInfo 
 * Calls the API to delete the record
 */
  delete(employeeInfo: any): Observable<any> {
    return this.http.delete(environment.baseUrl + '/hr/employees/' + employeeInfo.employee_id);
  }


  getDepartmentList(requestData: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/department/get', requestData);

  }

  getEmployeeCategoryList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/employeecategory/get', requestData);

  }

  getShopEmployeeMapping(employeeId: number): Observable<any> {
    return this.http.get(`${environment.baseUrl}/employee/shop-employee-mapping/${employeeId}`);
  }

  getEmployeeStatusesList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/hr/employee-statuses/list', requestData);
  }

  getEmployeeJobPositionsList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/hr/employee-job-positions/list', requestData);
  }

  getEmployeeTypeList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/wfm/employee-type/get', requestData);
  }

}
